import { supabase } from '@/integrations/supabase/client';
import { detectCurrencyFromBrowser, type SupportedCurrency } from '@/lib/currency';

/**
 * Get currency from browser locale. Only ever returns a supported currency
 * (GBP/EUR/USD) so the app never stores a value it cannot display.
 */
function getBrowserCurrency(): SupportedCurrency {
  return detectCurrencyFromBrowser();
}


/**
 * Bootstrap user data after first login - creates profile and settings if missing
 */
export async function bootstrapUserData(
  userId: string, 
  email: string,
  metadata?: Record<string, unknown>
): Promise<void> {
  try {
    // Check if profile exists
    const { data: profile } = await supabase
      .from('profiles')
      .select('user_id')
      .eq('user_id', userId)
      .maybeSingle();

    // Upsert profile if missing
    if (!profile) {
      await supabase
        .from('profiles')
        .upsert({
          user_id: userId,
          email,
          display_name: (metadata?.display_name as string) || null,
        }, {
          onConflict: 'user_id'
        });
    }

    // Check if user_settings exists
    const { data: settings } = await supabase
      .from('user_settings')
      .select('user_id')
      .eq('user_id', userId)
      .maybeSingle();

    // Upsert settings if missing
    if (!settings) {
      await supabase
        .from('user_settings')
        .upsert({
          user_id: userId,
          currency: getBrowserCurrency(),
          date_format: 'dd/mm/yyyy',
        }, {
          onConflict: 'user_id'
        });
    }
  } catch (error) {
    console.error('Failed to bootstrap user data:', error);
    // Don't throw - bootstrap should not block auth flow
  }
}
